<div
  class="transcript-content-inner"
  [class.mobile-transcript]="isMobile"
  #transcriptContentInner
  (scroll)="contentScrolled()"
>
  <!-- speakers -->
  @if (displaySpeaker && speakers.length) {
    <div class="speaker-item-wrapper">
      @for (speaker of speakers; track speaker.id) {
        <div class="speaker-item">
          <div class="speaker-content-container">
            <div class="speaker-name">{{ speaker.fullname }}</div>
            @if (speaker.position) {
              <div class="speaker-position">{{ speaker.position }}</div>
            }
          </div>
          <div class="speaker-image-wrapper">
            @if (!speaker.image) {
              <div class="picture-replacement">
                <span class="initials">{{ speaker.initials }}</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }

  <div>
    <p class="check-against-delivery">
      {{ 'Check against delivery' | translate }}
      <span class="mb-transcript-last-speaker-border"></span>
    </p>
  </div>
  <div class="transcript-entry-items">
    @for (entry of entries$ | async; track entry.id) {
      <div class="transcript-entry" [attr.data-id]="entry.id" [class.active]="currentEntry?.id === entry.id">
        @switch (entry.entryType) {
          <!-- speker template -->
          @case (entryTypes.TEXT) {
            <p class="transcript-entry-item transcript-entry-text" [innerHTML]="entry.text"></p>
          }
          <!-- link template -->
          @case (entryTypes.LINK) {
            <div class="transcript-entry-item transcript-entry-link">
              <a class="transcript-entry-link-wrapper btn btn-plain" [href]="entry.linkUrl" target="_blank">
                <span class="transcript-entry-link-label" [innerHTML]="entry.linkLabel"></span>
                <span class="transcript-entry-link-url" [innerHTML]="entry.linkDisplayUrl"></span>
              </a>
            </div>
          }
          <!-- quote template -->
          @case (entryTypes.QUOTE) {
            <div class="transcript-entry-item transcript-entry-item transcript-entry-quote">
              <i class="icon mb-icon-quotation-mark"></i>
              <span class="transcript-entry-quote-text" [innerHTML]="entry.quote"></span>
            </div>
          }
          <!-- image template -->
          @case (entryTypes.IMAGE) {
            <div class="transcript-entry-item transcript-entry-image">
              @for (media of entry.media; track media.id) {
                <ng-container *ngTemplateOutlet="imageTpl; context: { media: media }"></ng-container>
                <ng-template #imageTpl let-media="media">
                  <mb-image [media]="media" (click)="emitOpenMedia(media)"></mb-image>
                </ng-template>
                <mb-action-container [buttonItems]="buttonItems" [resource]="media"></mb-action-container>
              }
            </div>
          }
          <!-- video template -->
          @case (entryTypes.VIDEO) {
            <div class="transcript-entry-item transcript-entry-video">
              @for (media of entry.media; track media.id) {
                <ng-container *ngTemplateOutlet="videoTpl; context: { data: media }"></ng-container>
                <ng-template #videoTpl let-data="data">
                  @if (data.original) {
                    <mb-video
                      [media]="data"
                      [playerType]="playerType.INLINE"
                      [controls]="false"
                      [hoverVideo]="true"
                      [hideTitle]="true"
                      [muted]="true"
                      (click)="openVideoDialog(data)"
                    ></mb-video>
                  }
                </ng-template>
                <mb-action-container [buttonItems]="buttonItems" [resource]="media"></mb-action-container>
              }
            </div>
          }
          <!-- document template -->
          @case (entryTypes.DOCUMENT) {
            <div class="transcript-entry-item transcript-entry-document">
              @for (media of entry.media; track media.id) {
                <ng-container *ngTemplateOutlet="documentTpl; context: { data: media }"></ng-container>
                <ng-template #documentTpl let-data="data">
                  <mb-document-card
                    [document]="data"
                    [actions]="buttonItems"
                    (click)="emitOpenMedia(media)"
                  ></mb-document-card>
                </ng-template>
              }
            </div>
          }
          <!-- audio template -->
          @case (entryTypes.AUDIO) {
            <div class="transcript-entry-item transcript-entry-audio">
              @for (media of entry.media; track media.id) {
                <ng-container *ngTemplateOutlet="fooTpl; context: { data: media }"></ng-container>
                <ng-template #fooTpl let-data="data">
                  <mb-audio
                    class="no-bg compact"
                    [media]="data"
                    [actions]="buttonItems"
                    [disablePlay]="disableActionAssets"
                    (disablePlayClick)="checkCanOpen()"
                  ></mb-audio>
                </ng-template>
              }
            </div>
          }
        }
      </div>
      @if (entry.isLast && entry.speaker) {
        <div class="last-speaker-entry">
          {{ entry.speaker.fullname }}
          <span class="last-speaker-entry-border"></span>
        </div>
      }
    }
  </div>

  @if (isLoading()) {
    <mb-buffering></mb-buffering>
  }
</div>
